if ( typeof ProductQuantity !== 'function' ) {

  class ProductQuantity extends HTMLElement {

    constructor(){

      super();

      const qty = this.querySelector('.qty-selector'),
            qtyMinus = this.querySelector('.qty-minus'),
            qtyPlus = this.querySelector('.qty-plus'),
            qtyMin = 1,
            qtyMax = 999;

      if ( parseInt(qty.value) - 1 < qtyMin ) {
        qtyMinus.classList.add('disabled');
      }
      if ( parseInt(qty.value) + 1 > qtyMax ) {
        qtyPlus.classList.add('disabled');
      }


      function CalculateBogo(tierDiscount) {
        var singlePrice = jQuery('input[name="singleprice"]').val();
        var bottlePrice = jQuery('input[name="bottleprice"]').val();
        var singleInteger = parseFloat(singlePrice).toFixed(2);
        var bottleInteger = parseFloat(bottlePrice).toFixed(2);
        var priceDiscount = 0;
        var bottleDiscount = 0;
        if ((tierDiscount == 2) || (tierDiscount == 4) || (tierDiscount == 6) || (tierDiscount == 8) || (tierDiscount == 10) || (tierDiscount == 12) || (tierDiscount == 14) || (tierDiscount == 16) || (tierDiscount == 18) || (tierDiscount == 20) || (tierDiscount == 22) || (tierDiscount == 24)) {
          var priceDiscount = (singlePrice * (tierDiscount / 2));
          var bottleDiscount = (bottlePrice * (tierDiscount / 2));
        } else {
          var priceDiscount = (singlePrice * ((tierDiscount - 1) / 2));
          var bottleDiscount = (bottlePrice * ((tierDiscount - 1) / 2));
        }
        var singleFinalPrice = ((singleInteger * tierDiscount) - priceDiscount).toFixed(2);
        var bottleFinalPrice = (((bottleInteger * tierDiscount) - bottleDiscount) / tierDiscount).toFixed(2);
        var atcPrice = singleFinalPrice;
        var subPrice = (singleInteger * tierDiscount * 0.8).toFixed(2);
          if (priceDiscount > 0) {
            if (document.querySelector('recharge-subscription-widget')?.shadowRoot?.querySelector('input[value="subscription"]')) {
              if (isShadowRootInputChecked('input[value="onetime"]')) {
                $('#ff-new-per-bottle-price').html("Equivalent to  $" + bottleFinalPrice + " / bottle");
                $('[data-js-product-add-to-cart-text]').html('Add to Cart - $' + atcPrice + ' <s>$' + atcPrice + '</s>');
              } else {
                $('#ff-new-per-bottle-price').html("Equivalent to  $" + bottleInteger + " / bottle");
                $('[data-js-product-add-to-cart-text]').html('Add to Cart - $' + subPrice);
              }
            } else {
              $('#ff-new-per-bottle-price').html("Equivalent to  $" + bottleFinalPrice + " / bottle");
              $('[data-js-product-add-to-cart-text]').html('Add to Cart - $' + atcPrice + ' <s>$' + atcPrice + '</s>');
            }
          } else {
            $('#ff-new-per-bottle-price').html("Equivalent to  $" + bottleFinalPrice + " / bottle");
            if (document.querySelector('recharge-subscription-widget')?.shadowRoot?.querySelector('input[value="subscription"]')) {
              if (isShadowRootInputChecked('input[value="onetime"]')) {
                $('[data-js-product-add-to-cart-text]').html('Add to Cart - $' + atcPrice + ' <s>$' + atcPrice + '</s>');
              } else {
                $('[data-js-product-add-to-cart-text]').html('Add to Cart - $' + subPrice);
              }
            } else {
              $('[data-js-product-add-to-cart-text]').html('Add to Cart - $' + atcPrice + ' <s>$' + atcPrice + '</s>');
            }
          }
        // $('[data-js-product-variant] .product-variant__name').text('Size: 4-Pack');
        // $('.product-variant__container').hide();
      }

      function isShadowRootInputChecked(targetSelector) {
        // Find the shadow host
        const shadowHost = document.querySelector('recharge-subscription-widget');
        
        if (!shadowHost) {
            console.error("Shadow host not found: recharge-subscription-widget");
            return false; // Return false if the host is not found
        }

        // Access the shadow root
        const shadowRoot = shadowHost.shadowRoot;

        if (!shadowRoot) {
            console.error("Shadow root not found for the host: recharge-subscription-widget");
            return false; // Return false if the shadow root is not found
        }

        // Find the target input element inside the shadow root
        const inputElement = shadowRoot.querySelector(targetSelector);

        if (!inputElement) {
            console.error(`Input element not found: ${targetSelector}`);
            return false; // Return false if the input element is not found
        }

        // Return the checked state of the input element
        return inputElement.checked;
      }

      function updateRechargeWidgetText(newText) {
        // Find the shadow host
        const shadowHost = document.querySelector('recharge-subscription-widget');
        
        if (!shadowHost) {
            console.error("Shadow host not found: recharge-subscription-widget");
            return;
        }

        // Access the shadow root
        const shadowRoot = shadowHost.shadowRoot;

        if (!shadowRoot) {
            console.error("Shadow root not found for the host: recharge-subscription-widget");
            return;
        }

        // Find the target element inside the shadow root
        const targetElement = shadowRoot.querySelector('.rc-selection__onetime .rc-price');

        if (!targetElement) {
            console.error("Target element not found: .rc-price");
            return;
        }

        // Update the text content
        targetElement.innerHTML = newText;
      }
      function clickShadowRootInput(targetSelector) {
        // Find the shadow host
        const shadowHost = document.querySelector('recharge-subscription-widget');
        
        if (!shadowHost) {
            console.error("Shadow host not found: recharge-subscription-widget");
            return;
        }

        // Access the shadow root
        const shadowRoot = shadowHost.shadowRoot;

        if (!shadowRoot) {
            console.error("Shadow root not found for the host: recharge-subscription-widget");
            return;
        }

        // Find the target input element inside the shadow root
        const inputElement = shadowRoot.querySelector(targetSelector);

        if (!inputElement) {
            console.error(`Input element not found: ${targetSelector}`);
            return;
        }

        // Click the input element
        inputElement.click();
      }

      function hideShadowRootElement(targetSelector) {
        // Find the shadow host
        const shadowHost = document.querySelector('recharge-subscription-widget');
        
        if (!shadowHost) {
            console.error("Shadow host not found: recharge-subscription-widget");
            return;
        }

        // Access the shadow root
        const shadowRoot = shadowHost.shadowRoot;

        if (!shadowRoot) {
            console.error("Shadow root not found for the host: recharge-subscription-widget");
            return;
        }

        // Find the target element inside the shadow root
        const targetElement = shadowRoot.querySelector(targetSelector);

        if (!targetElement) {
            console.error(`Target element not found: ${targetSelector}`);
            return;
        }

        // Hide the target element
        targetElement.style.display = 'none';
      } 

      function showShadowRootElement(targetSelector) {
        // Find the shadow host
        const shadowHost = document.querySelector('recharge-subscription-widget');
        
        if (!shadowHost) {
            console.error("Shadow host not found: recharge-subscription-widget");
            return;
        }

        // Access the shadow root
        const shadowRoot = shadowHost.shadowRoot;

        if (!shadowRoot) {
            console.error("Shadow root not found for the host: recharge-subscription-widget");
            return;
        }

        // Find the target element inside the shadow root
        const targetElement = shadowRoot.querySelector(targetSelector);

        if (!targetElement) {
            console.error(`Target element not found: ${targetSelector}`);
            return;
        }

        // Hide the target element
        targetElement.style.display = 'block';
      } 

      function CalculateSinglePrice(tierDiscount) {
        var singlePrice = jQuery('input[name="singleprice"]').val();
        var bottlePrice = jQuery('input[name="bottleprice"]').val();
        var bottlePriceSub = jQuery('input[name="bottlepricesub"]').val();
        var singleInteger = parseFloat(singlePrice).toFixed(2);
        var bottleInteger = parseFloat(bottlePrice).toFixed(2);
        var bottleIntegerSub = parseFloat(bottlePriceSub).toFixed(2);
        var priceDiscount = 0;
        var bottleDiscount = 0;
        
          
        // $('[data-js-product-variant] .product-variant__nafme').text('Size: 4-Pack');
        // $('.product-variant__container').hide();
      }

      // jQuery(".onetime-radio").click(function() {
      //   const currentQty = parseInt(qty.value);
      //   console.log('click onetime')
      //   var tierDiscount = currentQty;
      //   CalculateSinglePrice(tierDiscount);
      // });

      qtyMinus.addEventListener('click', (e)=>{
        e.preventDefault();
        if ( ! qtyMinus.classList.contains('disabled') ) {
          const currentQty = parseInt(qty.value);
          if ( currentQty - 1 >= qtyMin ) {
            qty.value = currentQty - 1;
            qtyPlus.classList.remove('disabled');
          } 
          if ( currentQty - 1 <= qtyMin ) {
            qtyMinus.classList.add('disabled');
          }
          var tierDiscount = currentQty - 1;
          $('[data-js-product-quantity]').val(tierDiscount);
          
        }
      });

      qtyPlus.addEventListener('click', (e)=>{
        e.preventDefault();
        if ( ! qtyPlus.classList.contains('disabled') ) {
          const currentQty = parseInt(qty.value);
          if ( currentQty + 1 <= qtyMax ) {
            qty.value = currentQty + 1;
            qtyMinus.classList.remove('disabled');
          } 
          if ( currentQty + 1 >= qtyMax ) {
            qtyPlus.classList.add('disabled');
          }
          var tierDiscount = currentQty + 1;
          $('[data-js-product-quantity]').val(tierDiscount);
          
        }
      });

    }
    
  }


  if ( typeof customElements.get('product-quantityvariant') == 'undefined' ) {
    customElements.define('product-quantityvariant', ProductQuantity);
  }

}